<template>
    <LabelCommonCascder
        :options="optionsList"
        :label="label"
        v-bind="$attrs" 
        v-on="$listeners"
        @focus="cascderFocus"
        @visible-change="visibleChange"
        @expand-change="expandChange"
        collapse-tags
        :props="propsData"
        props.multiple = true
        filterable>
    </LabelCommonCascder>
</template>

<script>
import LabelCommonCascder from "@/components/label-input-v2/cascder";
export default {
    name: 'commonCascder',
    components: {
        LabelCommonCascder,
    },
    // data() {
    //     return {
    //         test: {
    //         lazy: true,
    //         lazyLoad (node, resolve) {
    //             const { level } = node;
    //             setTimeout(() => {
    //             const nodes = Array.from({ length: level + 1 })
    //                 .map(item => ({
    //                 value: 1,
    //                 label: `选项${1}${item}`,
    //                 leaf: level >= 2
    //                 }));
    //             // 通过调用resolve将子节点数据返回，通知组件数据加载完成
    //             resolve(nodes);
    //             }, 1000);
    //         }
    //         }
    //     }
    // },
    props: {
            label: {
                type: String,
                require: false,
                default: "label",
            },
            optionsList: {
                type: Array,
                require: false,
                default: (() => {
                    return  [{
                            value: 'te  st1',
                            label: 'test1',
                                children: [
                                    {
                                        value: 'test1',
                                        label: 'test1'
                                    },
                                    {
                                        value: 'ffsef',
                                        label: 'ffsef'
                                    },
                                ]
                            }]
                })
            },
            propsData: {
                type: Object,
                require: false,
                default: function() {
                    return {}
                }
            }
    },
    watch: {
        propsData: {
            handler(value) {
                console.log(value,'80');
            },
            deep: true
        }
    },
    methods: {
        cascderFocus() {
            console.log('81');
            document.querySelector('.el-cascader-menu__list').querySelectorAll('.el-checkbox').forEach(item => {
                item.style = 'display: none'
            })
        },
        visibleChange(value) {
            console.log(value,'93');
            if(value === false) {
                try {
                    let tagText = document.querySelectorAll('.el-tag')[1].children[0]
                    let changeText = tagText.innerText.replace(' ', '')
                    tagText.innerText = changeText
                } catch (error) {
                    return
                }
                
            }
        },
        expandChange(value) {
            setTimeout(() => {
                let dom = [...document.querySelectorAll('.el-cascader-menu__list')][1]
                if(dom.children[0].children[1].innerText === 'No Data') {
                    dom ? dom.querySelector('.el-checkbox').style = 'display: none' : ''
                    dom ? dom.querySelector('.el-cascader-node__label').style = `width: 100%;
                                                                              height: 200px;
                                                                              background: #fff;
                                                                              display: flex;
                                                                              align-items: center;
                                                                              margin-top: 150px;
                                                                              color: #ccc;
                                                                              justify-content: center;
                                                                              text-align:` : ''
                }else {
                    dom ? dom.querySelector('.el-checkbox').style = '' : ''
                }
            })
            console.log(value,'107');
        }
    },
    mounted() {
        // this.$nextTick(() => {
        //     let cascaderDom = document.querySelector('.el-cascader__tags')
        //     cascaderDom.style = 'display: none'
        // })
    }
}
</script>

<style scoped lang='scss'>
/deep/ .el-cascader {
    width: 100%;
    height: 36px !important;
    line-height: 36px !important;
    .is-focus::after{
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        width: calc(100%);
        height: calc(100%);
        border: 2px solid #c6d1f2;
        border-radius: 6px;
    }
    
}
/deep/ .el-cascader__search-input {
    display: none;
}
/deep/ .popper__arrow {
    display: none;
}
/deep/ .el-cascader-node .in-active-path {
    display: none;
}
</style>